import React, { useState } from 'react';
import { HelpCircle } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'src/components/ui/tooltip';
import SkuHelperModal from './sku-helper-modal';
import { SkuSuggestionContext } from './sku-helper.types';

interface SkuHelperButtonProps {
  context: SkuSuggestionContext;
  onApply: (sku: string | null) => void;
  disabled?: boolean;
  skus?: Array<{ id: string; sku: string; name?: string | null }>;
}

const SkuHelperButton: React.FC<SkuHelperButtonProps> = ({
  context,
  onApply,
  disabled = false,
  skus = [],
}) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <TooltipProvider delayDuration={300}>
        <Tooltip>
          <TooltipTrigger asChild>
            <button
              type="button"
              disabled={disabled}
              onClick={() => setOpen(true)}
              className="inline-flex size-7 shrink-0 items-center justify-center rounded-md border border-[#D9DBE3] bg-white text-[#5E6278] transition-colors hover:border-[#B8BBCA] hover:bg-[#F0F1F5] hover:text-[#0D0F1A] disabled:cursor-not-allowed disabled:opacity-50"
              aria-label="What SKU should I use?"
            >
              <HelpCircle className="size-4" />
            </button>
          </TooltipTrigger>
          <TooltipContent side="top">
            What SKU should I use?
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>

      <SkuHelperModal
        open={open}
        onClose={() => setOpen(false)}
        context={context}
        onApply={onApply}
        skus={skus}
      />
    </>
  );
};

export default SkuHelperButton;
